/**
 * @desc 获取全部列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmMaterialCategoryResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/plmMaterialCategory/getMaterialCategoryList`, {
      method: "GET",

      ...options,
    }),
  );
}
